import { useEffect, useState } from "react";
import StatsCard2 from "../../Global/StatsCard2";
import {
  UserGroupIcon,
  CursorArrowRippleIcon,
  ArrowLeftStartOnRectangleIcon,
} from "@heroicons/react/24/outline";
import SkeletonCard from "../../Skeleton/SkeletonCard";
import cdpService from "../../../apiService/cdp.service";

export default function StatsList2({ selectedFilters }) {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    const fetchStats = async () => {
      setLoading(true);
      setError("");
      try {
        const response = await cdpService.getFilteredRegistrationCount({
          product_id: selectedFilters?.product_id || null,
          registration_device: selectedFilters?.registration_device || null,
          start_date: selectedFilters?.start_date || null,
          end_date: selectedFilters?.end_date || null,
        });
        const payload = response.data;
        if (!payload?.success) {
          throw new Error(payload?.message || "Failed to fetch stats");
        }
        const counts = payload.data?.filteredRegistrationCounts || {};
        if (cancelled) return;
        setStats([
          {
            id: 1,
            name: "Filtered Total Registrations",
            subname: "All Users",
            stat: counts.filteredTotalRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.filteredTotalRegistrationCount?.toLocaleString() || "N/A",
            icon: UserGroupIcon,
            bg: "bg-red-50",
            iconcolor: "text-red-500",
          },
          {
            id: 2,
            name: "Filtered Migrated Users",
            subname: "Piano Users",
            stat: counts.filteredMigratedRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.filteredMigratedRegistrationCount?.toLocaleString() || "N/A",
            icon: CursorArrowRippleIcon,
            bg: "bg-green-50",
            iconcolor: "text-green-500",
          },
          {
            id: 3,
            name: "Filtered SSO Users",
            subname: "All SSO Users",
            stat: counts.filteredSsoRegistrationCount?.toLocaleString() || "N/A",
            substat: counts.filteredSsoRegistrationCount?.toLocaleString() || "N/A",
            icon: ArrowLeftStartOnRectangleIcon,
            bg: "bg-purple-50",
            iconcolor: "text-purple-500",
          },
        ]);
      } catch (loadError) {
        if (!cancelled) {
          setError(loadError.message || "Failed to fetch stats");
          setStats([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    fetchStats();
    return () => {
      cancelled = true;
    };
  }, [selectedFilters]);

  if (loading) return <SkeletonCard length={3} />;
  if (error) return <p className="text-red-500">Error: {error}</p>;

  return stats.map((item) => <StatsCard2 key={item.id} item={item} />);
}
